module.exports = __webpack_public_path__ + "images/beyond-image-carrot.ae36374d.svg";